import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { PopErrorHandler } from '@core/global/pop-error-handler';
import { TranslateService } from '@ngx-translate/core';
import { NGXLogger } from 'ngx-logger';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { PopExceptionDto } from './dto/pop-exception.dto';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  public constructor(
    private logger: NGXLogger,
    private translateService: TranslateService,
    private snackBar: MatSnackBar
  ) {}

  public intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return next.handle(request).pipe(
      catchError((error: HttpErrorResponse) => {
        this.logger.error(`${error.name} ${error.status}: ${error.message}`);

        try {
          let popError = error.error as PopExceptionDto;
          if (typeof error.error === 'string') { // this case occurs in the EstimateController
            popError = JSON.parse(error.error) as PopExceptionDto;
          }
          
          if (popError.errorCode != undefined) {
            const errorMessage = this.translateService.instant(`ERROR.CODE.${popError.errorCode}`) as string;
            const action = this.translateService.instant('BUTTON.CLOSE') as string;

            PopErrorHandler.hasErrors = true;
            const snackBarRef = this.snackBar.open(`${errorMessage}`, action, {
              horizontalPosition: 'end',
              verticalPosition: 'bottom',
              panelClass: ['error-snackbar'],
              duration: 30 * 1000
            });
            snackBarRef.afterDismissed().subscribe(() => {
              PopErrorHandler.hasErrors = false;
            });
          }
        } catch {
          // error showing the snackbar (dont do anything the error is logged later)
        }

        return throwError(() => error);
      })
    );
  }
}
